export default "__VITE_ASSET__83bf366d__"